import { z } from 'zod';

export const SUPPORTED_CURRENCY_CODES = [
  'USD',
  'JPY',
  'CNY',
  'EUR',
  'GBP',
  'HKD',
  'CAD',
  'AUD',
  'INR',
  'VND',
  'SGD',
] as const;

export const supportedCurrencyCodeSchema = z.enum(SUPPORTED_CURRENCY_CODES);

export type SupportedCurrencyCode = z.infer<typeof supportedCurrencyCodeSchema>;

export type CurrencyCode = 'KRW' | SupportedCurrencyCode;

export const exchangeRateSchema = z.object({
  currency: supportedCurrencyCodeSchema,
  rate: z.number().positive().finite(),
});

export type ExchangeRate = z.infer<typeof exchangeRateSchema>;

export const exchangeRatesResultSchema = z.object({
  base: z.literal('KRW'),
  updatedAt: z.string(),
  rates: z.array(exchangeRateSchema),
});

export type ExchangeRatesResult = z.infer<typeof exchangeRatesResultSchema>;
